import { Box, styled } from '@mui/material';

export const StyledSidebarNotificationBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '24px',
  fontSize: '12px',
  height: '24px',
  borderRadius: '24px',
  backgroundColor: theme.palette.lwPrimaryAccentDark[20],
}));
